<template>
    <div v-cloak>
      <div class="flex w-full">
        <div
          class="vx-col sm:w-1/3 w-full mb-2"
         
        >
          <vs-button
            @click="showBaseSalePricePopup()"
            class="vs-component vs-button bg_l_green"
             v-has-permission="'ModifyContractStore'"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />درج
            {{ $t("WarehouseName") }}
          </vs-button>

        </div>
      </div>
      <div class="vx-row pt-4">
        <div class="vx-col w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :columns="[{ title: $t('WarehouseId') }, { title: $t('WarehouseName') }]"
          >
            <template slot-scope="{ row }">
              <td style="width: 50%">
                {{ row.storeId }}
              </td>
              <td style="width: 50%">
                {{ row.storeName }}
              </td>
            </template>
          </data-grid>
        </div>
      </div>
  
      <base-sale-price-popup
        :show="baseSalePricePopup"
        :model="modalModel"
        @close="closeBaseSalePricePopup"
        @finish="baseSalePricePopupFinish"
      ></base-sale-price-popup>
    </div>
  </template>
  
  <script>
  import { mapActions } from "vuex";
  
  import DataGrid from "@/components/datagrid/DataGrid";
  import BaseSalePricePopup from "./BaseSalePricePopup.vue";
  
  export default {
    name: "saleManagement_Contract_Management_BaseSalePrice",
    components: {
      DataGrid,
      BaseSalePricePopup,
    },
    data() {
      var id = this.$route.params.id;
  
      return {
        gridDataSource: {
          type: "app",
          service: `/Sales/api/ContractStoreQuery/${id}`,
        },
        contractId:id,
        price:'',
        modalModel: {},
        model: {},
        baseSalePricePopup: false,
        updatePricePopup: false,
        selectedProducts: [],
  
      };
    },
    mounted() {},
  
    methods: {
  
  
      submitFilter() {
        this.$refs.grid.renderGrid(1, true);
      },
      resetForm() {
        setTimeout(() => {
          this.$refs.grid.renderGrid(1, true);
        }, 10);
      },
      showBaseSalePricePopup() {
        this.modalModel = { contractId: Number(this.$route.params.id) };
        this.baseSalePricePopup = true;
      },
      showUpdatePricePopup() {
        this.modalModelPrice = { contractId: Number(this.$route.params.id) };
  
        this.updatePricePopup = true;
      },
      closeBaseSalePricePopup() {
        this.modalModel = {};
        this.modalModelPrice = {};
        this.baseSalePricePopup = false;
        this.updatePricePopup = false;
      },
      baseSalePricePopupFinish() {
        this.closeBaseSalePricePopup();
        this.$refs.grid.renderGrid();
      },
    },
  };
  </script>
  
  <style scoped></style>
  